<template>
   <v-container fluid>
      <v-row no-gutters class="pa-0">
         <v-toolbar flat outlined>
            <v-btn small outlined color="indigo" class="ml-4 pa-2" @click="loadConsentData">
               <v-icon left>mdi-refresh</v-icon>
               <template v-if="$vuetify.breakpoint.mdAndUp">Refresh</template>
            </v-btn>
         </v-toolbar>
      </v-row>

      <!-- consent table -->
      <v-card flat outlined>
         <v-data-table
            dense
            :headers="consent_header"
            :items="consentdata"
            item-key="id"
            @click:row="consentRowClick"
            single-select
         >
         </v-data-table>
      </v-card>
   </v-container>
</template>

<script>
   export default {
      props: ["cca_id"],

      inject: ["ShowMessage"],

      data() {
         return {
            consent_header: [
               {
                  text: "Request Date",
                  value: "requestdate",
                  width: "15%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Request By",
                  value: "requestbyname",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Type",
                  value: "subcategorytext",
                  width: "15%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Consent Date",
                  value: "consentdate",
                  width: "15%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Student Name",
                  value: "stdfullname",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Status",
                  value: "consentstatustext",
                  width: "15%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Consentor",
                  value: "consentorname",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
            consentdata: [],
         };
      },
      methods: {
         consentRowClick(item, row) {
            row.select(!row.isSelected);
         },

         async loadConsentData() {
            await this.$http({
               url: "/cca/getconsentactivity.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.cca_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.consentdata = response.data.consentdata;
                  }
               }
            });
         },
      },

      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.loadConsentData();
         }
      },
   };
</script>
